var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { RequestClient } from "../basics/request-client.service";
import { autoinject, transient } from "aurelia-dependency-injection";
import { Api } from "../../constants/modules/api.constants";
import { toNative } from "../../utilities/promise-utils";
var AttachmentClientService = /** @class */ (function () {
    function AttachmentClientService(requestClient) {
        this.requestClient = requestClient;
    }
    AttachmentClientService.prototype.addAttachments = function (request, progressCallback) {
        var e_1, _a;
        var formData = new FormData();
        if (request.files)
            formData.append("files", request.files);
        try {
            for (var _b = __values(request.dataUris), _c = _b.next(); !_c.done; _c = _b.next()) {
                var dataUri = _c.value;
                formData.append("dataUris", dataUri);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return toNative(this.requestClient.postWithProgressCallback(Api.Attachments.Save, progressCallback, {}, formData));
    };
    AttachmentClientService = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [RequestClient])
    ], AttachmentClientService);
    return AttachmentClientService;
}());
export { AttachmentClientService };
